<!-- eslint-disable @angular-eslint/template/interactive-supports-focus -->
<!-- eslint-disable @angular-eslint/template/click-events-have-key-events -->
@if (allTiers()()) {
  <div class="wager-drawer" [ngStyle]="drawerStyles | theme">
    <div [ngClass]="glowClass"></div>

    <app-nav-button
      icon="close"
      (clickEvent)="onCloseClick()"
      [variant]="drawerConfig.closeButtonInverted ? 'secondary' : 'primary'"
      [size]="drawerConfig.closeButtonSize"
      [ngClass]="drawerConfig.closeButtonPosition"
    />

    <app-wager-tier-list
      [isInDrawer]="true"
      [allTiers]="allTiers()"
      [freeMatches]="freeMatches()"
      [currentTournamentData]="currentTournamentData()"
      [soloTiers]="soloTiers()"
      [paymentInFlight]="paymentInFlight"
      [waitingOpponentsStandard]="waitingOpponentsStandard()"
      (wagerClickEvent)="onWagerClick($event)"
      (tournamentPlayClickEvent)="onTournamentPlayClick($event)"
      (freeMatchClickEvent)="onFreeMatchClick($event)"
      (soloClickEvent)="onSoloClick()"
      (practiceClickEvent)="onPracticeClick()"
      (localClickEvent)="onLocalClick()"
    />
  </div>
}
